import React, { useState, useEffect } from 'react';
import Table from '../../../components/utils/Table'
import Button from '../../../components/utils/Button'
import Alert from '../../../components/utils/Alert'
import { useForm } from 'react-hook-form'
import { useSelector, useDispatch } from 'react-redux'
import portinActivationAction from '../../../redux/portinActivation/actions';
import authActions from '../../../redux/auth/actions';
import Papa from 'papaparse';
import SideButtons from '../../../components/utils/SideButtons'
import ArrowLeftLineIcon from 'remixicon-react/ArrowLeftLineIcon'
import DownloadCloud2sLineIcon from 'remixicon-react/DownloadCloud2LineIcon';

const Uploadcolumns = [
    { displayName: '#', key: 'key' },
    { displayName: 'SERIAL NUMBER', key: 'ICCID' },
    { displayName: 'MOBILE NUMBER', key: 'PhoneNumber' },
    { displayName: 'ACCOUNT NUMBER', key: 'PortingAccountNumber' },
    { displayName: 'STATUS', key: 'ResponseStatus' },
]

const { resetMessage, checkSerialNumberByBatch, updateManualPortinActivation } = portinActivationAction;
const { getUserDataByToken } = authActions;
const BASE_URL = process.env.REACT_APP_SITE_BASE_URL;

const ManualPortinUpdate = ({ hide ,search}) => {
    const dispatch = useDispatch();
    const [previewData, setPreviewData] = useState([]);
    const [fileName, setFileName] = useState('');
    const [showAlert, setShowAlert] = useState(false);
    const [alertType, setAlertType] = useState('');
    const [alertText, setAlertText] = useState('');
    const { checkSerialNumberLoading, checkSerialNumberResult, updateManualPortinActivationLoading, updateManualPortinActivationError, updateManualPortinActivationMessage } = useSelector((state) => state.portinActivation);
    const { register, handleSubmit, setError, clearErrors, reset, formState: { errors }, setError: bulkUpadteSetError, } = useForm({ defaultValues: '' });

    useEffect(() => {
        if (updateManualPortinActivationError !== null && updateManualPortinActivationError !== undefined) {
            displayAlert(updateManualPortinActivationError, 'alert-danger');
        }
        if (updateManualPortinActivationMessage !== null && updateManualPortinActivationMessage !== undefined) {
            reset();
            dispatch(getUserDataByToken());
        }
    }, [updateManualPortinActivationError, updateManualPortinActivationMessage]);

    useEffect(() => {
        const statusData = checkSerialNumberResult?.[1];
        if (Array.isArray(statusData) && statusData.length > 0) {
            const isValid = statusData.some(item => item.Status === 1);
            const isInvalid = statusData.some(item => item.Status === 0);

            if (isValid) {
                bulkUpadteSetError("uploadedFile", { type: "custom", message: '' });
            } else if (isInvalid) {
                setPreviewData([]);
                bulkUpadteSetError("uploadedFile", { type: "custom", message: statusData[0].Message, });
            } else {
                setPreviewData([]);
                bulkUpadteSetError("uploadedFile", { type: "custom", message: statusData[0].Message, });
            }
        }
    }, [checkSerialNumberResult]);

    useEffect(() => {
        if (checkSerialNumberResult && Array.isArray(checkSerialNumberResult[0])) {
            const allStatuses = checkSerialNumberResult[0].map(item => item.RequestStatus);
            const hasInvalidStatus = allStatuses.some(status => status !== 49);

            // if (hasInvalidStatus || false) {
            //     setError("uploadedFile", {
            //         type: "custom",
            //         message: "Only ICCIDs with Request Status Upload CSV are allowed.",
            //     });
            //     setPreviewData([]);
            //     return;
            // }
        }
    }, [checkSerialNumberResult]);

    const displayAlert = (text, type) => {
        setAlertText(text);
        setAlertType(type);
        setShowAlert(true);
    };

    const alertCancel = () => {
        setShowAlert(false);
        setAlertText('');
        setAlertType('');
        dispatch(resetMessage());
        dispatch(getUserDataByToken());
    }

    const handleClose = () => {
        hide()
        reset();
        setPreviewData([])
        dispatch(resetMessage());
    }

    const handleFileChange = (e) => {
        const fileReader = new FileReader();
        let file = e.target.files[0];
        setPreviewData([]);
        setFileName("");
        clearErrors("uploadedFile");
        if (!file) {
            setError("uploadedFile", { type: "custom", message: "Csv is required!", });
            return;
        }

        const fileNameWithExt = file.name;
        const fileName = fileNameWithExt.substring(0, fileNameWithExt.lastIndexOf('.')) || fileNameWithExt;
        setFileName(fileName);

        const fileExt = fileNameWithExt.split('.').pop().toLowerCase();
        if (fileExt !== "csv") {
            setError("uploadedFile", { type: "custom", message: "Invalid file type. Only CSV file allowed.", });
            return;
        }

        fileReader.onload = async ({ target }) => {
            const csvOutput = Papa.parse(target.result, { header: true, skipEmptyLines: true });
            const parsedData = csvOutput?.data;
            const columns = Object.keys(parsedData[0]);

            const requiredHeaders = ['ICCID', 'Phone Number', 'Porting Account Number', 'Response Status'];
            const isValidCsvHeading = requiredHeaders.every((header) => columns.includes(header));

            if (isValidCsvHeading) {
                const serialNumbers = parsedData.map((item) => item['ICCID']).filter((iccid) => iccid);
                if (serialNumbers.length > 0) {
                    dispatch(checkSerialNumberByBatch(serialNumbers));
                }
                const mappedData = parsedData.map((item, index) => ({
                    key: index + 1,
                    ICCID: item['ICCID'],
                    PhoneNumber: item['Phone Number'],
                    PortingAccountNumber: item['Porting Account Number'],
                    ResponseStatus: item['Response Status'],
                }));
                setPreviewData(mappedData);
            } else {
                setError("uploadedFile", {
                    type: "custom", message: "Invalid Csv Selected",
                });
            }
        };

        fileReader.readAsText(file);
    };


    const handleManulSubmit = () => {
        const validSerials = checkSerialNumberResult?.[0]?.filter(item => item.RequestStatus === 49)?.map(item => item.SerialNumber);
        const filteredReportData = previewData.filter(item => validSerials.includes(item.ICCID));

        if (filteredReportData.length === 0) {
            alert("No valid data to submit.");
        } else {
            const newData = {
                BatchID: fileName,
                BulkTransactionID: checkSerialNumberResult?.[1]?.[0]?.BatchID,
                RequestSource: 1,
                ReportData: filteredReportData,
                ErrorDesc: ""
            };
            dispatch(updateManualPortinActivation(newData,search));
        }
    };

    const downloadSampleFile = () => {
        let url = `${BASE_URL}/assets/csv/isp-sample_file.csv`;
        let link = document.createElement('a');
        link.href = url;
        link.click();
    }

    return (
        <>
            <div className='mr-2 row align-items-center justify-content-end  portinBackButton'>
                <SideButtons title="Back" buttonStyle="primary" onClick={() => hide()} btnIcon={<ArrowLeftLineIcon />} />
                <button type="button" onClick={() => downloadSampleFile()} style={{ background: '#2ecc71', color: '#fff', pointerEvents: 'auto', marginLeft: '5px', height: '40px' }} className={`btn font-weight-bold mr-2`}><DownloadCloud2sLineIcon size={16} />Sample File</button>
            </div>
            <form onSubmit={handleSubmit(handleManulSubmit)}>
                <div className="col-md-6 mb-3">
                    <div className="input-group">
                        <label htmlFor="csvFile"><span className='text-danger'>*</span>Upload File </label>
                        <input
                            type="file"
                            className="form-control-file"
                            name='uploadedFile'
                            id="csvFile"
                            accept='.csv'
                            {...register('uploadedFile', { required: 'Csv is required' })}
                            onChange={(e) => handleFileChange(e)}
                        />
                        <small class="text-danger">Note : Each batch's ICCID should be uploaded separately.</small>
                        {errors && errors.uploadedFile && (<div className="invalid-feedback">{errors.uploadedFile.message}</div>)}
                    </div>

                </div>
                {checkSerialNumberResult?.[1]?.[0]?.Status === 1 && (
                    <div className="col-md-6 mb-3">
                        <div className="d-flex align-items-center">
                            <span className="mb-0 me-2 fw-bold" style={{ fontWeight: '700', color: 'black', fontSize: '18px' }}>Batch Transaction ID:</span>
                            <span className="fw-bold text-center" style={{ marginLeft: '5px', fontWeight: '500' }}>
                                {checkSerialNumberResult?.[1]?.[0]?.BatchID}
                            </span>
                        </div>
                    </div>
                )}

                {showAlert && updateManualPortinActivationError && <div className='mt-4'><Alert type={alertType} text={alertText} closeBtn={alertCancel} /></div>}
                {previewData.length > 0 && (
                    <Table columns={Uploadcolumns} data={previewData} loading={checkSerialNumberLoading} pagination={true} />)}
                <div className='text-right row mt-2'>
                    <div className="col-md-12">
                        {previewData.length > 0 && (
                            <div>
                                <button type="button" className="btn btn-secondary mr-2" onClick={handleClose}>Close</button>
                                <Button title="Submit" style="minWidth:80px" loading={updateManualPortinActivationLoading} buttonClass="btn btn-primary" buttonType="submit" />
                            </div>
                        )}
                    </div>
                </div>
            </form>
        </>
    )
}

export default ManualPortinUpdate